import React from 'react'
import styled from 'styled-components'
import { SelectionGroup } from './index'

const StyledLevelRadioGroup = styled(SelectionGroup).attrs({
  multiSelect: true,
  initItems: [
    { id: 'elc', text: 'ELC', value: 'elc' },
    { id: 'kinder', text: 'Kinder', value: 'kinder' },
    { id: 'primary', text: 'Primary', value: 'primary' },
    { id: 'secondary', text: 'Secondary', value: 'secondary' },
  ],
})``

interface ILevelSelectionGroupProps {
  labelText?: string
  validationMessage?: string
  required?: boolean
  onChange?: (obj: { [key: string]: boolean }) => void
  value?: { [key: string]: boolean }
  name?: string
}

const LevelSelectionGroup: React.FC<ILevelSelectionGroupProps> = ({
  labelText,
  validationMessage,
  required = false,
  value,
  onChange,
}) => {
  const keys = Object.keys(value || {})
  const newValue = keys.filter((k) => {
    return value[k] === true
  })
  return (
    <StyledLevelRadioGroup
      labelText={labelText}
      validationMessage={validationMessage}
      required={required}
      value={newValue}
      onChange={(updateValue: any) => {
        const obj: { [key: string]: boolean } = {
          elc: false,
          kinder: false,
          primary: false,
          secondary: false,
        }
        updateValue.forEach((v: string) => {
          obj[v] = true
        })
        onChange(obj)
      }}
    />
  )
}

export { LevelSelectionGroup }
